import { resolveAdfRichText } from '@/lib/adf-renderer';
import {
    resolveJiraWikiRichText,
    type IncidentRichText,
    type JiraWikiAttachmentReference,
    type JiraWikiRichText,
} from '@/lib/jira-wiki';

type ResolveIncidentRichTextOptions = {
    attachments?: JiraWikiAttachmentReference[];
};

export type ResolvedIncidentRichText = IncidentRichText & {
    inlineAttachmentIds?: string[];
    inlineAttachmentFileNames?: string[];
};

export function resolveIncidentRichText(
    text: string | null | undefined,
    options?: ResolveIncidentRichTextOptions,
): ResolvedIncidentRichText {
    if (!text) {
        return {
            text: '',
            renderAsHtml: false,
        };
    }

    const adfRichText = resolveAdfRichText(text, options);
    if (adfRichText) return adfRichText;

    const jiraWikiRichText = resolveJiraWikiRichText(text, options);
    if (jiraWikiRichText) return jiraWikiRichText as JiraWikiRichText;

    return {
        text,
        renderAsHtml: false,
    };
}
